import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DropdownInput.module.css";
import { HelperError, Label } from "./ShortTextInput";

export default function DropdownInput(props) {
  const {
    label,
    name,
    options,
    value,
    error, //error message
    helperText, //helper text message below the input
    id,
    fullWidth,
    labelColor,
    placeholder,
    onChange,
    onBlur,
    className,
    maxWidth,
    noOptionsText,
    required, // show required field indicator if true
  } = props;

  return (
    <div
      className={className}
      style={{
        width: fullWidth ? "100%" : "auto",
        maxWidth: maxWidth ? maxWidth : "300px",
      }}
    >
      {/* Label */}
      {label && <Label id={id} required={required} label={label}  />}

      {/* Dropdown */}
      <select
        id={id}
        name={name}
        onBlur={onBlur}
        value={value}
        onChange={onChange}
        className={classNames(styles.inputBase, {
          [styles.inputError]: error,
        })}
        aria-describedby={`${id}-helper-text`}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options?.length > 0 ? (
          options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))
        ) : (
          <option disabled>{noOptionsText?noOptionsText:"No options available"}</option>
        )}
      </select>

      {/* Helper Text */}
      {(helperText || error) && <HelperError id={id} error={error} helperText={helperText}/>}
    </div>
  );
}

// Default Props
DropdownInput.defaultProps = {
  label: "",
  options: [],
  value: "",
  onChange: () => {},
  error: "",
  helperText: "",
  id: "custom-dropdown",
  fullWidth: false,
  labelColor: "",
  placeholder: "Select an option",
  name: "",
  className: "",
  maxWidth: "",
  noOptionsText: "",
};

// Prop Types
DropdownInput.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  labelColor: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  maxWidth: PropTypes.string,
  required: PropTypes.bool,
  noOptionsText: PropTypes.string,
};